import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import usePropertyZone from "./useStateLaws";
import { Search } from "lucide-react";

const StateLaws = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    stateLawList,
    isStateLawLoading,
    isRefetchingStateLaw,
    isOwner,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    hasAddPermission
  } = usePropertyZone();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="State Laws" />
          {!isOwner && isMobile && hasAddPermission && (
            <Button onClick={onAdd} className="px-2">
              + Add Laws
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isOwner && !isMobile && hasAddPermission && <Button onClick={onAdd}>+ Add Laws</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isStateLawLoading || isRefetchingStateLaw ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={stateLawList?.data?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            ) || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(stateLawList?.total / pageSize)}
            totalRecords={stateLawList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default StateLaws;
